import axios from 'axios'
import {createSlice, createAsyncThunk, PayloadAction} from '@reduxjs/toolkit'
const api = '/api/'

export const saleList = createAsyncThunk('sale-list', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get(`${api}sale/list`, params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const getAllStaffList = createAsyncThunk('sale-staff', async (__, thunkAPI) => {
  try {
    const response = await axios.get(`${api}sale/staff-list`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const storeSale = createAsyncThunk('sale-store', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}sale/store`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data)
    }
  }
})

export const getExistsItemStock = createAsyncThunk(
  'sale-exists-item-stock',
  async (__, thunkAPI) => {
    try {
      const response = await axios.get(`${api}sale/item-stock`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const viewSale = createAsyncThunk('sale-view', async (sale_id: any, thunkAPI) => {
  try {
    const response = await axios.get(`${api}sale/view/` + sale_id)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data)
    }
  }
})

export const getSaleById = createAsyncThunk('sale-edit', async (sale_id: any, thunkAPI) => {
  try {
    const response = await axios.get(`${api}sale/edit/` + sale_id)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data)
    }
  }
})

export const saleReport = createAsyncThunk('sale-report', async (params: any, thunkAPI) => {
  try {
    return await axios.get(`${api}sale/report`, {params})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const saleReportPrint = createAsyncThunk(
  'sale-report-print',
  async (params: any, thunkAPI) => {
    try {
      const res = await axios.get(`${api}sale/report-print`, {params})
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

type SaleState = {
  errors: any
}

const initialState: SaleState = {
  errors: '',
}

export const saleSlice = createSlice({
  name: 'sale',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(storeSale.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
  },
})

export const {reset} = saleSlice.actions
export default saleSlice.reducer
